/**
 * Global helper: on touch devices, prevent Radix dialogs/sheets/drawers from
 * auto-focusing the first focusable element when they open, so the on-screen
 * keyboard doesn't pop. Desktop behavior is unchanged.
 */
export function isTouchDevice(): boolean {
  return (
    typeof window !== "undefined" &&
    ("ontouchstart" in window || (navigator?.maxTouchPoints ?? 0) > 0)
  );
}

export function createTouchOpenAutoFocusHandler(
  userHandler?: (e: Event) => void
) {
  return (e: Event) => {
    if (isTouchDevice()) {
      e.preventDefault();
    }
    userHandler?.(e);
  };
}

/**
 * Ref callback that focuses the element ONLY on non-touch devices.
 * Use as a drop-in replacement for the `autoFocus` prop on inputs inside
 * dialogs/sheets, so the mobile keyboard doesn't auto-open.
 */
export const desktopAutoFocusRef = (
  el: HTMLInputElement | HTMLTextAreaElement | null
) => {
  if (el && !isTouchDevice()) {
    requestAnimationFrame(() => el.focus());
  }
};
